<template>
  <section class="cookies">
    <div class="cookies-background"></div>
    <div class="cookies-content">
      <h4>Damos valor à sua privacidade</h4>
      <p>Com a sua permissão, nós e os nossos parceiros podemos usar dados precisos de localização geográfica e identificação através da digitalização do dispositivo. Pode clicar para consentir com o nosso processamento e o dos nossos parceiros, conforme descrito acima. Como alternativa, pode aceder a informações mais detalhadas e alterar as suas preferências antes de consentir ou recusar o consentimento. Observe que algum do processamento dos seus dados pessoais pode não exigir o seu consentimento, mas tem o direito de se opor a esse processamento. As suas preferências serão aplicadas apenas a este website.</p>
      <elvasButton :button="{title: 'Aceitar'}" @click.native="acceptCookies()"></elvasButton>
    </div>
  </section>
</template>
<script>
import elvasButton from './elvas-button.vue'
export default {
  components: { elvasButton },
  name: 'cookies',
  methods: {
    acceptCookies () {
      localStorage.setItem('accept-cookies', true)
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.cookies {
  z-index: 200;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  .cookies-background {
    position: relative;
    width: 100%;
    height: 100%;
    opacity: 0.35;
    background-color: #242424;
  }
  .cookies-content {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background: white;
    padding: 48px;
    width: 60%;
    height: fit-content;
    h4 {
      font-size: 32px;
      font-weight: bold;
      color: #a79374;
      margin-bottom: 16px;
    }
    p {
      line-height: 26px;
    }
    .elvas-button {
      margin-left: auto;
    }
  }

  @media screen and (max-width: 670px){
    .cookies-content {
      overflow: auto;
      height: 70%;
    }

    .elvas-button {
      width: 80%;
      margin: 16px auto;
    }
  }
}
</style>